import React from 'react';

function ChooseDesigner () {
  return (
    <div className="row">
      <div className="col-md-9 col-center">
          <h1 className="bold-italics blue text-center mb50">
            So, do I choose my own designer?
          </h1>
          <p className="ls1">
            <span className="bold">No way! Finding and managing design talent is a job of its own </span>
            and can cause low quality results. We believe that pairing each
            designer with a product manager is the best way to ensure success.
          </p>
          <p className="ls1 mt30 mb50">
            <span className="bold">You'll be in direct communication with your very own product manager </span>
            to go over vision and scope. They'll be working behind the scenes to
            get your design shipped and on time.
          </p>
      </div>
    </div>
  );
}

export default ChooseDesigner;



// WEBPACK FOOTER //
// ./src/components/ChooseDesigner/index.js